import { FC, ComponentProps } from 'react';
import { Route } from 'react-router-dom';
import { ApiErrorProvider } from './ApiErrorContext';

interface IRouteWithApiErrorProps {
    exact: boolean;
    path: ComponentProps<typeof Route>['path'];
}

export const RouteWithApiError: FC<IRouteWithApiErrorProps> = ({ exact, path, children }) => {
    return (
        <Route exact={exact} path={path}>
            <ApiErrorProvider>{children}</ApiErrorProvider>
        </Route>
    );
};
